module.exports = __webpack_public_path__ + "img/MottoCenter-D-TOOLS-Mimecast.d578a16f.png";